const formatDac7Deadline = (deadline: string): string => {
  const locale = 'pl-PL';
  const dateObj = new Date(deadline);
  const date = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long' }).format(dateObj);
  return date;
};

export default formatDac7Deadline;
